import { mapGetters } from 'vuex'
import moment from 'moment'

import { getLastCron, getNextCron } from '@/utils/time/cron.utils'

export default {

  computed: {
    ...mapGetters(['currentPresenterLanguage']),
    userLanguageInMomentFormat() {
      return this.currentPresenterLanguage
    },
    reportCronMessage() {
      const { lastCron, nextCron } = this.getCronRoutine()
      return this.$i18nPresenter.t('cron_report_message', {
        last: moment(lastCron).locale(this.userLanguageInMomentFormat).fromNow(),
        next: moment(nextCron).locale(this.userLanguageInMomentFormat).fromNow(),
      })
    },
  },
  methods: {
    getCronRoutine() {
      const intervalHours = 2 // or your custom interval
      const referenceTime = new Date() // current time

      // Calculate last and next cron times
      const lastCron = getLastCron(intervalHours, referenceTime)
      const nextCron = getNextCron(lastCron, intervalHours)

      return {
        lastCron,
        nextCron,
      }
    },
  },
}
